import './inbox_content.js.coffee'
import './inbox_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.MediaAttachment extends Backbone.Model

  initialize: (media) =>
    @media = media

  url:=>
    @media.media_url

  is_twitter_gif: =>
    false

  is_twitter_video:=>
    false

  is_file: =>
    @media.type == 'file'

  filename: =>
    @media.filename || ''
